<script>
    import resize from "./resize";

    export default {

        mixins: [resize],

        computed: {
            actualMode() {
                if (this.moreMode === 'table') {
                    return this.actualWidth < 1023
                } else {
                    return this.actualWidth < 767
                }
            }
        },

        methods: {
            getAdaptiveMode(name, isHeader = false) {
                let currentAdaptive;

                if(isHeader) {
                    currentAdaptive = name.adaptiveMode
                } else {
                    currentAdaptive = this.tableHead.find(item => item.name === name).adaptiveMode;
                }

                if (currentAdaptive === 'none') {
                    return 'is-tablet'
                } else if (currentAdaptive === 'tablet') {
                    return 'is-mobile'
                }
            },
        }
    }
</script>